export const ABSENCE_SHEETS = "/api/folder-groups/:param/absence-sheets"
export const ABSENCE_SHEET = "/api/folder-groups/:param/absence-sheets/:absenceSheetGroupParam"

export const GENERATE_GLOBAL_RESULT = "/api/folder-groups/:param/absence-sheets/generate/:lang"

export const ABSENCE_SHEET_DEACTIVATE = "/api/folder-groups/:param/absence-sheets/:absenceSheetGroupParam/deactivate"
export const ABSENCE_SHEET_ACTIVATE = "/api/folder-groups/:param/absence-sheets/:absenceSheetGroupParam/activate"
